module.exports = __webpack_public_path__ + "img/7_ward_15.88afed73.png";